
$(function () {
    $('.input-group[data-show-hide-password] button[data-show]').on('click', function () {
        $(this).closest('.input-group').find('input[type="password"]')[0].type = 'text';
        $(this).siblings('[data-hide]').show();
        $(this).hide();
    });

    $('.input-group[data-show-hide-password] button[data-hide]').on('click', function () {
        $(this).closest('.input-group').find('input[type="text"]')[0].type = 'password';
        $(this).siblings('[data-show]').show();
        $(this).hide();
    });
});

// This is a poolyfil to make 'startsWith' work in IE
if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function (search, pos) {
            pos = !pos || pos < 0 ? 0 : +pos;
            return this.substring(pos, pos + search.length) === search;
        }
    });
}

window.snapToFirstInvalidElement = function () {

    // Get first invalid element
    var $elem = $('.is-invalid:visible:first');

    if (!$elem.length) {
        // If there's no invalid input, fallback to any visible validation messages
        $elem = $('.field-validation-error:visible:first');
    }

    if ($elem.length) {
        // Get top offset of first invalid element
        var offTop = $elem.offset().top;

        // Take off half(ish) of the viewport height - so the element will be roughly in the middle
        offTop -= $(window).height() / 2.5;

        // Scroll to the calculated position
        $('html').scrollTop(offTop);
    }
}

$(function (){
    $('#printPage').on('click', function() {
        window.print();
    });

    $('[data-toggle="tooltip"]').tooltip({
        //delay: { show: 0, hide: 100000 } // Useful for debugging!
    });
});
